import { Typography } from '@execonline-inc/execonline-ui';
import { just } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import { sanitizeHtml } from '../../../../Utils/sanitizeHtml';
import { findLinkBy } from '../../../../Links';
import DateTime from '../../Shared/DateTime';
import ImageComponent from '../../Shared/ImageComponent';
import { RecentActivityResource } from './Decoders';

interface Props {
  recentActivities: NonEmptyList<RecentActivityResource>;
}

function Row({ recentActivities }: Props) {
  return recentActivities.toArray().map((activity, index) => (
    <div key={index} className="flex items-center mb-4">
      <div className="flex items-center">
        <ImageComponent
          size="sm"
          imgLink={findLinkBy({ rel: 'avatar' }, activity.links)}
          altText={`Avatar for ${activity.payload.userName}`}
        />
      </div>
      <div className="flex flex-col ml-2.5">
        <Typography
          variant="bodyMedium"
          color="dark"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(activity.payload.contentHtml) }}
        />
        <DateTime position="text-start" dateTime={just(activity.payload.createdAt)} />
      </div>
    </div>
  ));
}

export default observer(Row);
